module.exports = __webpack_public_path__ + "static/media/fly0047.7cadcc2f.webp";